import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { GeneralDetails } from './components/GeneralDetails'
import { useRequirementDetailContextValue } from './context/RequirementDetailProvider'
import { Questions } from './components/Questions'
import { AssociatedPositions } from './components/AssociatedPositions'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'

const RequirementDetailHeader = () => {
  const { state, actions } = useRequirementDetailContextValue()

  return (
    <Header
      title={`${state.name} (${state.id})`}
      subTitle="Requirement Detail"
      rightContent={
        <Flex
          alignItems="center"
          gap={2}
          data-context-key="requirement_id"
          data-context-value={state.id}
          data-context-label={state.name}
        >
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
        </Flex>
      }
    />
  )
}

export const RequirementDetailMain = () => {
  const {
    state: { verificationType },
  } = useRequirementDetailContextValue()
  const showQuestions = verificationType === 'assessment'

  return (
    <>
      <RequirementDetailHeader />
      <Box margin={3}>
        <GeneralDetails />
        <br />
        <br />
        {showQuestions ? (
          <>
            <Questions />
            <br />
          </>
        ) : null}
        <AssociatedPositions />
      </Box>
    </>
  )
}
